module.exports = __webpack_public_path__ + "img/9788926390580.b97288f5.jpg";